export default __webpack_public_path__ + "static/media/physiotherapist-and-boy-holding-ball-pxfq-9-hy.1452952d.png";